import angular from 'angular';
import ngeoMapFeatureOverlayMgr from 'ngeo/map/FeatureOverlayMgr';
import * as olEvents from 'ol/events.js';
import olFeature from 'ol/Feature.js';
import olGeomPoint from 'ol/geom/Point.js';
import olObservable from 'ol/Observable.js';
import olStyleRegularShape from 'ol/style/RegularShape.js';
import olStyleStroke from 'ol/style/Stroke.js';
import olStyleFill from 'ol/style/Fill.js';
import olStyleStyle from 'ol/style/Style.js';

/**
 * @private
 */
class Controller {
  /**
   * @param {angular.IScope} $scope Angular scope.
   * @param {angular.IWindowService} $window The Angular $window service.
   */
  constructor($scope, $window) {
    // Binding properties

    /**
     * The current floor (from dimensions).
     * @type {string}
     * @export
     */
    this.floor;

    /**
     * @type {ol.Map}
     * @export
     */
    this.map;

    // Injected properties

    /**
     * @type {!angular.Scope}
     * @private
     */
    this.scope_ = $scope;

    /**
     * @type {angular.$window}
     */
    this.window_ = $window;

    // Inner properties

    /**
     * @type {import('ngeo/map/FeatureOverlay').FeatureOverlay}
     * @export
     */
    this.featureOverlay_ = ngeoMapFeatureOverlayMgr.getFeatureOverlay();

    /**
     * @type {Array.<ol.EventsKey>}
     * @private
     */
    this.listenerKeys_ = [];

    /**
     * @type {!ol.geom.Point}
     * @private
     */
    this.point_ = undefined;

    this.featureOverlay_.setStyle(
      new olStyleStyle({
        image: new olStyleRegularShape({
          angle: Math.PI / 4,
          fill: new olStyleFill({color: 'red'}),
          points: 4,
          radius: 10,
          radius2: 0,
          stroke: new olStyleStroke({color: 'black', width: 2}),
        }),
      }),
    );
  }

  /**
   * Called on initialization of the controller.
   */
  $onInit() {
    const view = this.map.getView();
    const center = view.getCenter();
    if (!center) {
      throw new Error('View should have center set');
    }
    this.point_ = new olGeomPoint(center);

    // Create and add feature to feature overlay
    const feature = new olFeature({
      geometry: this.point_,
    });
    this.featureOverlay_.addFeature(feature);

    // Watch floor change
    this.scope_.$watch(
      () => this.floor,
      () => this.handleChange_(false),
    );

    this.listenerKeys_.push(olEvents.listen(view, 'change:center', () => this.handleChange_(true), this));
  }

  /**
   * Called on initialization of the controller.
   * @param {boolean} centerChanged Whether the center changed or not. If it did,
   *     update the point coordinates.
   * @private
   */
  handleChange_(centerChanged) {
    let center = this.map.getView().getCenter();
    if (!center) {
      throw new Error('View should have center set');
    }

    if (centerChanged) {
      this.point_.setCoordinates(center);
    }

    center = center.map((val) => Math.floor(10 * val) / 10);
    this.window_.parent.postMessage(
      {
        'center': center,
        'floor': Number(this.floor),
      },
      '*', // allow any parent: we don't care if this information is sniffed
    );
  }

  /**
   * Called on destruction of the controller.
   */
  $onDestroy() {
    // Remove feature from feature overlay
    this.featureOverlay_.clear();

    // Unregister OL events
    olObservable.unByKey(this.listenerKeys_);
    this.listenerKeys_.length = 0;
  }
}
Controller.$inject = ['$scope', '$window'];

/**
 * @hidden
 */
const gmfModule = angular.module('epflBackToInvApp', []);

gmfModule.component('epflBackToInvApp', {
  bindings: {
    'floor': '=',
    'map': '<',
  },
  controller: Controller,
});

export default gmfModule;
